import React, { Fragment } from 'react';
import { makeStyles, Container, Typography, Box, Link } from '@material-ui/core';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'black', 
    color: theme.palette.primary.main, 
    minHeight: '100vh',
    maxWidth: '1800px',
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(8), 
  },
  mainCompanyWrapper : {
    width : "60%",
    textAlign : "center", 
    margin: "0 auto", 
  },
  heading: {
    color: theme.palette.primary.main, 
    fontSize: '32px', 
    marginBottom: theme.spacing(2),
  },
  description: {
    color: theme.palette.primary.main, 
    textAlign : "justify",
    fontSize: '18px', 
    fontWeight: 300,
  },
  specialDescription: {
    backgroundColor: theme.palette.primary.main,
    color: 'black',
    textAlign: 'justify',
    fontSize: '13px',
    fontWeight: 400,
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(8),
  },
  footer: {
    marginTop: theme.spacing(16),
    textAlign: 'center',
  },
  footerLink: {
    margin: '0 10px',
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
}));

function BooksCatalog() {
  const classes = useStyles();

  return (
    <Container className={classes.root}>
      <Container className={classes.mainCompanyWrapper}>
        <Typography variant="p" className={classes.heading} align="center">
        d2p’s KleverBook™ App
        </Typography>
        <Box marginTop={4}> 
          <Typography variant="body1" className={classes.description} align="center">
          The KleverBook app (patent pending) allows registered users free access to eBooks listed on d2p’s catalog. In exchange for free access, however, each chapter in every eBook has an unskippable 30-second click ad, which must run before the next chapter can be read. The revenue generated from KleverBook ads is then shared with that eBook’s author/publisher, which enables the reader free access.
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Authors and publishers seeking to participate in d2p’s KleverBook program must create an account with Continent 5 Media at <Link href="www.C5M.world" target="_blank" style={{ color: '#0563C1',textDecoration : "underline" }}>www.C5M.world</Link> or <Link href="www.Continent5Media.com" target="_blank" style={{ color: '#0563C1',textDecoration : "underline" }}>www.Continent5Media.com</Link>. 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Once registered with C5M, authors and publishers are redirected to d2p's website, where they sign up, create their custom page, and then upload a digital copy of each book they seek to submit for the KleverBook program.
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Each eBook is then modified through KleverBook software to insert Ad Slots.
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          An Ad Slot interrupts the eBook's text to insert (or remove) a Chapter Ad. 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          A Chapter Ad is a static or 30-second video ad that will appear at the end of each chapter (or at 15-page intervals). 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Chapter Ads cannot be skipped and will remain in their static form (or, if video, played) for 30 seconds before the next chapter can be unlocked for reading. 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Chapter Ads reset and replay each time a chapter is re-read. 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          A chapter is considered being read if the user does not exit the section between Ad Slots within 30 seconds.  
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Ad Slots are permanent, whereas Chapter Ads are not.
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          All Chapter Ads have a hyperlink, which, when activated by the reader, lands them on the catalog page of the Retailer (whose ad is showing), unless the ad is from an Industrial brand (such as GEICO, Spirit Airlines, or political campaigns), in which case a link to that entities’ website is provided.
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          A typical 350-page novel will show at least 24 Chapter Ads (or roughly one every 15 pages, depending on chapter length). Thus, a typical story will have 24 hyperlinks to 24 product catalogs or industrial-brand websites. 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Each modified eBook is then cataloged on d2p’s site according to the author, title, and category (in alphabetical order). 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Visitors to d2p's site can shop and purchase eBooks from its catalog, or they can download the KleverBook app and read select eBooks for free, but only online. 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Once an eBook has been selected for reading on the KleverBook app, our software instantly loads Chapter Ads in that book's Ad slots. 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Chapter Ads come from C5M’s Ad Module—a database where ads are stored for automated retrieval each time a KleverBook is selected.
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Chapter Ads are placed in C5M’s Ad Module in the order that they will be inserted in the Ad Slots (i.e., by bid amount/Ad Level or time and date logged into the system (see Ad Pricing Schedule below). 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Once the Chapter Ads are installed, the book is uploaded through the KleverBook app onto the reader's device for online access. 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Because KleverBooks can only be read online, Chapter Ads can be removed, updated, or rotated. 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Readers who activate hyperlinks to Retailers' catalogs and Industry-brand websites can return to their eBook page anytime. 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Readers can purchase items through the KleverBook app. 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          All purchases are processed by C5M, which automatically deducts a 12% commission and a 3% processing fee (in most cases) before routing the residual to the Retailer’s account.
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Authors and publishers who participate in ekspIode!'s KleverBook program receive a 6% discount from the 12% commission charged from selling their books on d2p’s platform, 2.5% of revenue generated (if any) from sales conducted through each Chapter Ad installed on the author's/publisher's downloaded book, and  50% of ad revenue generated from the Chapter Ads installed on the author’s/publisher's downloaded eBook.
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          An eBook downloaded through the KleverBook app expires after 60 days.
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          Payments owed to authors/publishers are made within 24 hours of the 30th and 60th day from the time and date the eBook was downloaded. 
          </Typography>
          <Typography variant="body1" className={classes.description} align="center" style={{marginTop: '16px'}}>
          For KleverBook pricing and ad placement information, please activate the Pricing tab.
          </Typography>
        </Box>
      </Container>
      <Container className={classes.footer}>
      <NavLink to="/pricing" className={classes.footerLink}>Pricing</NavLink>
        <NavLink to="/register/:role" className={classes.footerLink}>Join</NavLink>
        <NavLink to="/" className={classes.footerLink}>Home</NavLink>
      </Container>
    </Container>
  );
}

export default BooksCatalog;
